import React, { useState } from "react";
import { 
  EditOptionContainer, 
  EditOptionTitle, 
  EditOptionDescription, 
  FormGroup, 
  Button, 
  ButtonGroup,
  LoadingSpinner,
  InputSlider,
  TipBox,
  RadioGroup,
  Switch
} from "../EditOptionStyles";
import { removeBackground } from "../../utils/editUtils";

const RemoveBackground = ({ onSubmit, isLoading }) => {
  const [precision, setPrecision] = useState(80);
  const [mode, setMode] = useState("auto");
  const [preserveShadow, setPreserveShadow] = useState(false);
  
  const handleSubmit = () => {
    // Gather options for API call
    const options = { 
      precision: precision / 100, 
      mode,
      preserveShadow
    };
    
    // Pass the editType and apiFunction to the parent
    onSubmit({
      editType: "removeBackground",
      apiFunction: removeBackground
    });
  };

  const modeOptions = [
    { value: "auto", label: "Auto" },
    { value: "precise", label: "Precise" },
    { value: "fast", label: "Fast" }
  ];

  return (
    <EditOptionContainer>
      <div>
        <EditOptionTitle icon="🎭">Remove Background</EditOptionTitle>
        <EditOptionDescription>
          Automatically remove the background from your image, isolating the main subject with precision.
        </EditOptionDescription>
      </div>

      <ButtonGroup>
        <Button 
          primary={false} 
          outline={true} 
          onClick={() => {
            setPrecision(80);
            setMode("auto");
            setPreserveShadow(false);
          }}
        >
          Reset
        </Button>
        <Button 
          onClick={handleSubmit} 
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <LoadingSpinner />
              Processing...
            </>
          ) : (
            "Remove Background"
          )}
        </Button>
      </ButtonGroup>
    </EditOptionContainer>
  );
};

export default RemoveBackground;
